import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const UPDATE_CHILD_PROFILE_MUTATION = mutation({
  updateChildProfile: [
    { input: input('input', 'UpdateChildProfileInput!') },
    {
      success: true,
    },
  ],
});

type UpdateChildProfileInputType = VariablesOf<typeof UPDATE_CHILD_PROFILE_MUTATION>['input'];
type UpdateChildProfileResponseType = ResultOf<typeof UPDATE_CHILD_PROFILE_MUTATION>['updateChildProfile'];

export const updateChildProfileMutationRequest = async (
  props: UpdateChildProfileInputType
): Promise<ResultType<UpdateChildProfileResponseType>> => {
  const client = getReadingCrittersClientUtil();

  try {
    const response = await client.mutation(UPDATE_CHILD_PROFILE_MUTATION, { input: props }, { useAuth: true });

    return {
      success: Boolean(response?.updateChildProfile?.success),
      data: response?.updateChildProfile ?? { success: false },
    };
  } catch (error) {
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};
